import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import type { InstalledComponent } from 'features/versions/types'
import { appAPI } from 'utils/app-api'

export function useInstalledComponents() {
  const res = useQuery<InstalledComponent[]>({
    queryKey: ['getInstalledSoftware'],
    queryFn: () => appAPI.getInstalledComponents(),
    staleTime: 0,
  })
  const patchedRes = { ...res, installedComponents: res.data ?? [] }
  delete patchedRes.data
  return patchedRes
}

// null means we're in browser
export type PRESYNC_VERSION = string | 'PRESYNC_IN_BROWSER'

export const useAppVersion = (): PRESYNC_VERSION | undefined => {
  const [version, setVersion] = useState<PRESYNC_VERSION | undefined>()

  useEffect(() => {
    appAPI.getAppVersion().then((_version) => {
      setVersion(_version)
    })
  }, [])

  return version
}
